// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 9/6/2023
 */


.LoginForm_formContainer__C\\+lMR {
    display: flex;
    flex-direction: column;
    align-items: center; 
    text-align: center; 
}

.LoginForm_formItem__UXL7S{
    margin-bottom: 20px;
    
}

.LoginForm_formText__AoPPo{
    background: #FFF;
    box-shadow: 2px 2px 50px 2px #657FAD1A;
    margin-top: 10px;
}

.LoginForm_formLabel__2VQcn{
    margin-top: 50px;
    margin-bottom: 8px;
    padding-top: 10rem !important;
    font-weight: 600 !important;
}


.LoginForm_form__I201i{
    display:flex;
    flex-direction: column;
}

.LoginForm_btn__eVTH0{
    flex: 1 1;
}

.LoginForm_btn__eVTH0{
    flex: 1 1 auto;
    justify-content: center;
    display: flex;
    gap: 10px;
    flex-direction: column;
}

.LoginForm_button__VBoxh{
    border-radius: 0.5rem;
    padding: 0.5rem 2.5rem;

}

.LoginForm_logo__KmC1E {
    max-width: 100px; 
    margin-bottom: 1rem;
}
.LoginForm_submitButton__p5QlR{
margin-top: 20px;
}

.LoginForm_formContainer__C\\+lMR {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.LoginForm_formItem__UXL7S {
    margin-top: 1rem;
}

@media (max-width: 600px) {
    .LoginForm_parentDiv__5ql-Y {
        padding: 1rem;
    }

    .LoginForm_paperStyle__QxstZ {
        padding: 1rem;
        max-width: 100%;
    }

    .LoginForm_logo__KmC1E {
        max-width: 90px; 
    }

    .LoginForm_formItem__UXL7S {
        margin-top: 0.8rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Login/LoginForm.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;AAGF;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;AAC/B;;;AAGA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;;AAE1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;AACA,gBAAgB;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 9/6/2023\r\n */\r\n\r\n\r\n.formContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; \r\n    text-align: center; \r\n}\r\n\r\n.formItem{\r\n    margin-bottom: 20px;\r\n    \r\n}\r\n\r\n.formText{\r\n    background: #FFF;\r\n    box-shadow: 2px 2px 50px 2px #657FAD1A;\r\n    margin-top: 10px;\r\n}\r\n\r\n.formLabel{\r\n    margin-top: 50px;\r\n    margin-bottom: 8px;\r\n    padding-top: 10rem !important;\r\n    font-weight: 600 !important;\r\n}\r\n\r\n\r\n.form{\r\n    display:flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.btn{\r\n    flex: 1;\r\n}\r\n\r\n.btn{\r\n    flex: 1 1 auto;\r\n    justify-content: center;\r\n    display: flex;\r\n    gap: 10px;\r\n    flex-direction: column;\r\n}\r\n\r\n.button{\r\n    border-radius: 0.5rem;\r\n    padding: 0.5rem 2.5rem;\r\n\r\n}\r\n\r\n.logo {\r\n    max-width: 100px; \r\n    margin-bottom: 1rem;\r\n}\r\n.submitButton{\r\nmargin-top: 20px;\r\n}\r\n\r\n.formContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n.formItem {\r\n    margin-top: 1rem;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    .parentDiv {\r\n        padding: 1rem;\r\n    }\r\n\r\n    .paperStyle {\r\n        padding: 1rem;\r\n        max-width: 100%;\r\n    }\r\n\r\n    .logo {\r\n        max-width: 90px; \r\n    }\r\n\r\n    .formItem {\r\n        margin-top: 0.8rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `LoginForm_formContainer__C+lMR`,
	"formItem": `LoginForm_formItem__UXL7S`,
	"formText": `LoginForm_formText__AoPPo`,
	"formLabel": `LoginForm_formLabel__2VQcn`,
	"form": `LoginForm_form__I201i`,
	"btn": `LoginForm_btn__eVTH0`,
	"button": `LoginForm_button__VBoxh`,
	"logo": `LoginForm_logo__KmC1E`,
	"submitButton": `LoginForm_submitButton__p5QlR`,
	"parentDiv": `LoginForm_parentDiv__5ql-Y`,
	"paperStyle": `LoginForm_paperStyle__QxstZ`
};
export default ___CSS_LOADER_EXPORT___;
